import * as React from 'react';

import { AmenityViewModel } from 'models';

import { UitkIcon } from 'uitk-react-icons';

import { addIcon } from 'utils/amenity-mapper';

interface AmenitiesGridProps {
  amenities: AmenityViewModel[];
}

export const AmenitiesGrid: React.FunctionComponent<AmenitiesGridProps> = ({ amenities }) => {
  const numOfAmenities = 4;
  const truncatedAmenities = amenities.slice(0, numOfAmenities);
  const amenityClasses = 'uitk-cell all-b-margin-two all-cell-1-2';

  return (
    <React.Fragment>
      <ul className="uitk-type-list-300 icon-m uitk-grid">
        {truncatedAmenities.map((amenityWithoutIcon, index) => {
          const amenity = addIcon(amenityWithoutIcon);
          const amenityDescription = amenity.description;
          const amenityIcon = amenity.icon;

          return (
            <li className={amenityClasses} key={`amenity-${index}-${amenityDescription}`}>
              <div className="uitk-grid">
                <UitkIcon className="uitk-cell all-cell-shrink all-t-margin-two" id={`amenity-icon-${amenityIcon}`} name={amenityIcon} />
                <span className="uitk-cell all-cell-fill all-t-margin-two">{amenityDescription}</span>
              </div>
            </li>
          );
        })}
      </ul>
    </React.Fragment>
  );
};

AmenitiesGrid.displayName = 'AmenitiesGrid';
